import { useMutation } from 'react-query';
import axios from 'axios';

export const useDeleteVideo = () =>
  useMutation(
    ['deleteVideo'],
    async (videoId) => {
      const url =
        `/kodak-api/api/v1/media/videos/${videoId}`;
      const res = await axios.delete(url);
      return res.data;
    },
  );
